import {
  ADMIN_ACTIONS,
  CUSTOMER_ACTIONS,
  CUSTOMER_PAYROLL_DISABLED_ACTIONS,
  SUPERADMIN_ACTIONS,
  CUSTOMER_PAYROLL_SETUP_ACTIONS,
  IAction,
  generateAdminAccountActions,
} from 'components/common/sidebar/constant';
import { useLocation } from 'react-router-dom';
import {
  useAcceptTermsOfServiceStatus,
  useCurrentCompany,
  useCurrentUser,
  useCurrentUserRole,
  usePayrollOnboardingStatus,
  usePermissions,
  useSpoof,
} from 'hooks/api';
import { extractIdsFromUrl } from './desktop/helpers';

const isAccountDetailPath = (pathname: string) => {
  const { accountId } = extractIdsFromUrl(pathname);
  return !!accountId;
};

export const useMenuItems = (): IAction[] => {
  const { pathname } = useLocation();
  const { currentUser, isLoading } = useCurrentUser();
  const { currentCompany } = useCurrentCompany();
  const { isAdmin, isLoginUserSuperAdmin } = useCurrentUserRole();
  const { spoofUserID, isAdminSpoof } = useSpoof();
  const { onboardingStatus, isError: onboardingStatusError } =
    usePayrollOnboardingStatus(currentCompany?.id, {
      enabled: !!currentCompany?.id && !currentCompany?.disabledPayroll,
    });
  const { accepted, isError: acceptedStatusError } =
    useAcceptTermsOfServiceStatus(currentCompany?.id);
  const { hasPermission } = usePermissions();

  if (currentUser == null || isLoading) {
    return [];
  }

  if (isAdmin && isAccountDetailPath(pathname)) {
    const pathArray = pathname.substring(1).split('/');
    return generateAdminAccountActions(pathArray[2]);
  }

  // check if user is super admin and not spoofing
  if (isLoginUserSuperAdmin && !spoofUserID) {
    return [...ADMIN_ACTIONS, ...SUPERADMIN_ACTIONS];
  }

  if (isAdmin) {
    return ADMIN_ACTIONS;
  }

  if (currentCompany?.disabledPayroll === false) {
    if (
      (onboardingStatus.onboardingCompleted === false &&
        onboardingStatus.isStepCompleted('started_customer_onboarding') ===
          false) ||
      (!hasPermission('read:payrolls:all') && isAdminSpoof)
    ) {
      return CUSTOMER_PAYROLL_DISABLED_ACTIONS;
    }

    if (
      accepted === false ||
      onboardingStatus.companyApproved === false ||
      onboardingStatusError ||
      acceptedStatusError
    ) {
      return CUSTOMER_PAYROLL_SETUP_ACTIONS;
    }
  }

  return CUSTOMER_ACTIONS;
};
